module.exports = __webpack_public_path__ + "img/0bb421b9b693ad9012354e98c0670582.png";